enum FeatureFlagValues {
  isInContextEditorEnabled = "isInContextEditorEnabled",
  isRewardDisabled = "isRewardDisabled",
  isRecognitionReactionsEnabled = "isRecognitionReactionsEnabled",
  isInsChatroomEnabled = "isInsChatroomEnabled",
  isCustomisationEnabled = "isCustomisationEnabled"
}

export default FeatureFlagValues
